

































import Vue from 'vue';
import Component from 'vue-class-component';
import BindAttrs from '@/utils/binds-attrs';
import {Prop} from 'vue-property-decorator';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import '@/compiled-icons/download';

import * as pdfjs from 'pdfjs-dist/webpack';
import {PDFDocumentProxy, PDFPageProxy} from 'pdfjs-dist/webpack';
import PDFPage from '@/fields/pdf/AmetrasPdfPageContentTemplate.vue';
import {ResizeSensor} from 'css-element-queries';
import {throttle} from 'lodash';
import {PDFPromise} from 'pdfjs-dist';

interface PageSetup {
  proxy: PDFPageProxy;
  scale: number;
}

@Component({
  components: {PDFPage},
  mixins: [BindAttrs]
})
export default class AmetrasPdfFieldTemplate extends Vue {
  @Prop({
    required: false
  }) value!: string;
  @Prop({
    required: false
  }) label!: string;
  loading: boolean = false;
  pages: PageSetup[] = [];

  $refs!: {
    pdfWrapper: HTMLDivElement
  };

  private pdf: PDFDocumentProxy | null = null;

  mounted() {
    this.loading = true;
    HTTP_SERVICE_INSTANCE.getAxios().get(this.value, {
      responseType: 'arraybuffer'
    }).then((result) => {
      this.loading = false;
      pdfjs.getDocument(result.data).promise.then((pdf: PDFDocumentProxy) => {
        this.pdf = pdf;
        this.loadPdfPages();
        const resizeSensor = new ResizeSensor(this.$refs.pdfWrapper, throttle(() => {
          this.loadPdfPages();
        }, 500));
      });
    }, () => {
      this.loading = false;
    });
  }

  loadPdfPages() {
    if (this.pdf) {
      this.loading = true;

      const pageLoadPromises: Array<PDFPromise<any>> = [];
      for (let currentPageIndex = 1; currentPageIndex <= this.pdf.numPages; currentPageIndex++) {
        const currentPageLoadPromise = this.pdf.getPage(currentPageIndex);
        pageLoadPromises.push(currentPageLoadPromise);
        currentPageLoadPromise.then((loadedPage) => {
          const defaultViewPort = loadedPage.getViewport({scale: 1});
          const targetWidth = this.$refs.pdfWrapper.getBoundingClientRect().width;
          this.pages[loadedPage.pageIndex] = {
            scale: targetWidth / defaultViewPort.width,
            proxy: loadedPage
          };
        });
      }
      Promise.all(pageLoadPromises).then(() => {
        this.loading = false;
      });
    }
  }

}
